<template>
  <div class="header">
    <div class="w1200">
      <div class="logo"></div>
      <div class="right">
        <ul class="nav">
          <li>
            <a href="javascript:;" class="a1" @click="$router.push({name: 'index'})">{{ $t('index')}}</a>
          </li>
          <li>
            <a href="javascript:;" class="a1 subnavlink" @click="$router.push({name: 'about'})">{{ $t('about')}}</a>
            <div class="subnav">
              <a href="javascript:;" @click="$router.push({name: 'about',params: {type:1}})">{{ $t('introduction')}}</a>
              <a href="javascript:;" @click="$router.push({name: 'about',params: {type:2}})">{{ $t('culture')}}</a>
              <a href="javascript:;" @click="$router.push({name: 'about',params: {type:3}})">{{ $t('development')}}</a>
            </div>
          </li>
          <li>
            <a href="javascript:;" class="a1 subnavlink" @click="$router.push({name: 'prodlist'})">{{ $t('productCenter')}}</a>
            <div class="subnav">
              <a href="javascript:;" @click="$router.push({name: 'prodlist'})">{{ $t('product')}}</a>
              <a href="javascript:;" @click="$router.push({name: 'quality'})">{{ $t('quality')}}</a>
              <a href="javascript:;" @click="$router.push({name: 'application'})">{{ $t('application')}}</a>
            </div>
          </li>
          <li>
            <a href="javascript:;" class="a1 subnavlink" @click="$router.push({name: 'technology'})">{{ $t('technology')}}</a>
            <div class="subnav">
              <a href="javascript:;" @click="$router.push({name: 'technology'})">{{ $t('technology')}}</a>
              <a href="javascript:;" @click="$router.push({name: 'science'})">{{ $t('science')}}</a>
              <a href="javascript:;" @click="$router.push({name: 'patent'})">{{ $t('patent')}}</a>
            </div>
          </li>
          <li>
            <a href="javascript:;" class="a1" @click="$router.push({name: 'cooperation'})">{{ $t('cooperation')}}</a>
          </li>
          <li>
            <a href="javascript:;" class="a1 subnavlink" @click="$router.push({name: 'environment'})">{{ $t('environment')}}</a>
            <div class="subnav">
              <a href="javascript:;" @click="$router.push({name: 'environment'})">{{ $t('anquanhuanbao')}}</a>
              <a href="javascript:;" @click="$router.push({name: 'welfare'})">{{ $t('welfare')}}</a>
              <a href="javascript:;" @click="$router.push({name: 'care'})">{{ $t('care')}}</a>
            </div>
          </li>
          <li>
            <a href="javascript:;" class="a1 subnavlink" @click="$router.push({name: 'newslist'})">{{ $t('newslist')}}</a>
            <div class="subnav">
              <a href="javascript:;" @click="$router.push({name: 'newslist'})">{{ $t('newsnava')}}</a>
              <a href="javascript:;" @click="$router.push({name: 'building'})">{{ $t('newsnavb')}}</a>
            </div>
          </li>
          <li>
            <a href="javascript:;" class="a1 subnavlink" @click="$router.push({name: 'personnel'})">{{ $t('personnel')}}</a>
            <div class="subnav">
              <a href="javascript:;" @click="$router.push({name: 'personnel'})">{{ $t('personnelnav')}}</a>
              <a href="javascript:;" @click="$router.push({name: 'recruit'})">{{ $t('recruit')}}</a>
            </div>
          </li>
        </ul>
        <div class="language">
          <span @click="changeLanguage('cn')">中文</span>
          <span @click="changeLanguage('en')">EN</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      language: ''
    }
  },
  mounted () {
    if (localStorage.getItem('lang') === 'cn') {
      this.language = '中文'
    } else {
      this.language = 'EN'
    }
  },
  methods: {
    changeLanguage (data) {
      if (data === 'cn') {
        this.$i18n.locale = 'cn'
        localStorage.setItem('lang', 'cn')
      } else {
        this.$i18n.locale = 'en'
        localStorage.setItem('lang', 'en')
      }
      location.reload()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .header{
        position: absolute;
        top: 0;
        width: 100%;
        left: 0;
        z-index: 20;
        height: 82px;
    }
    .header .w1200{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 82px;
      overflow: visible;
    }
    .header .logo{
      display: block;
      width: 124px;
      height: 32px;
      background: url(../assets/logo.png) 0 0 no-repeat;
    }
    .header .right{
      display: flex;
      align-items: center;
    }
    .header .right .nav{
      display: flex;
      align-items: center;
    }
    .header .right .nav li{
      width: auto;
      height: 82px;
      margin-right: 44px;
      position: relative;
    }
    .header .right .nav li .subnav{
      position: absolute;
      min-width: 138px;
      height: auto;
      left: 50%;
      margin-left: -30px;
      background-color: #fff;
      top: 74px;
      left: 0;
      display: none;
    }
    .header .right .nav li:hover .subnav{
      display: block;
    }
    .header .right .nav li .subnav::before{
      content: "";
      position: absolute;
      top: -6px;
      width: 100%;
      height: 6px;
      background:url(../assets/subnavbg.png) center 0 no-repeat
    }
    .header .right .nav li:hover .a1{
      color: #e50a20;
    }
    .header .right .nav li .subnav a{
      min-width: 100%;
      height: 40px;
      line-height: 40px;
      box-sizing: border-box;
      padding-left: 40px;
      padding-right: 5px;
      display: block;
      color: #999;
      white-space: nowrap;
      position: relative;
    }
    .header .right .nav li .subnav a:hover{
      color: #333;
      background-color: #f6f6f6;
    }
    .header .right .nav li .subnav a:hover::after{
      content: "";
      width: 2px;
      height: 8px;
      background-color: #e50a20;
      position: absolute;
      left: 29px;
      top: 50%;
      margin-top: -4px;
    }
    .header .right .nav li .a1{
      width: 100%;
      height: 82px;
      line-height: 82px;
      padding-right: 14px;
      font-size: 16px;
      color: #fff;
      display: block;
    }
    .header .right .nav li .subnavlink{
      background: url(../assets/subnavicon.png) right center no-repeat;
    }
    .header .right .language{
      width: auto;
      height: 20px;
      position: relative;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .header .right .language span{
      padding-left: 5px;
      line-height: 14px;
      padding-right: 5px;
      cursor: pointer;
    }
    .header .right .language span:nth-child(1){
      border-right: 1px solid #fff;
    }
    /* .header .right .language .language-subbox{
      position: absolute;
      top: 28px;
      left: 8px;
      background-color: #fff;
      width: 32px;
      height: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
    .header .right .language .language-subbox span{
      display: block;
      line-height: 28px;
      width: 100%;
      height: 28px;
      color: #999999;
      text-align: center;
      font-size: 12px;
      cursor: pointer;
    }
    .header .right .language .language-subbox span:hover{
      color: #333;
      background-color: #f6f6f6;
    }
    .header .right .language:hover .language-subbox{
      height: 56px;
    } */
</style>



// WEBPACK FOOTER //
// src/pages/header.vue